// Bireysel SEO sayfalarının rota listesi — ana pakete büyük içerik dosyası
// (bireyselData.js) girmeden App.js'in rotaları kurabilmesi için hafif modül.
// Yeni bireysel sayfa eklenirken hem buraya hem bireyselData.js'e eklenmeli.
export const BIREYSEL_ROUTES = [
  "/bireysel",
  "/ucretsiz-butce-uygulamasi",
  "/gelir-gider-takibi",
  "/ev-yonetimi",
  "/doviz-altin-takibi",
  "/fis-okuma",
];
